<template>
    <div class="flex">

        <slot v-bind:open="open">
            <button @click="open" class="cursor-pointer rounded py-2 block text-grey-dark font-bold">
                <i class="fa fa-folder-open-o"></i> Load
            </button>
        </slot>

        <portal to="modals" v-if="showModal">
            <modal @close="showModal = false">
                <div slot="header">Load Report</div>

                <p class="mb-4 text-grey-dark text-sm">load an existing data report from your sheets collection</p>

                <loading v-show="loading"></loading>

                <div v-if="!loading">
                    <ul class="list-reset shadow">
                        <li v-for="panel in panels" class="block flex border-b justify-between">
                            <a :href="'/en/dashboards/' + panel.id"
                               class="block w-full cursor-pointer text-grey-darkest flex hover:bg-blue-lighter p-4">
                                <div class="mr-4"><i class="fa fa-file-o"></i></div>
                                <div>
                                    {{ panel.headline }}
                                    <span class="ml-2" title="shared" v-show="panel.visibility !== 'private'">
                                        <i class="fa fa-users"></i>
                                    </span>

                                </div>
                            </a>
                            <a @click="remove(panel.id)" class="ml-4 cursor-pointer p-4 hover:text-red text-grey">
                                <i class="fa fa-trash"></i>
                            </a>
                        </li>
                        <li v-show="panels.length === 0" class="p-4">
                            no saved sheets found.
                        </li>
                    </ul>

                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
    export default {
        name: "LoadFile",

        data: () => ({
            showModal: false,
            loading: false,
            panels: [],
        }),

        methods: {
            open() {
                this.showModal = true;
                this.load();
            },
            load() {
                this.loading = true;
                let that = this;
                http.get('/panels').then((response) => {
                    that.panels = response.data.panels;
                    that.loading = false;
                });
            },
            remove(id) {
                if (!confirm('do you want to delete?')) {
                    return;
                }

                let that = this;

                http.post("/panels/" + id, {
                    '_method': 'delete',
                }).then((response) => {
                    that.load();
                })
            }
        }
    }
</script>

<style scoped>

</style>
